import React, { type FC } from 'react';

export const Overview: FC = () => {
    const overviewImage = new URL('./overview.png', import.meta.url).toString();

    return (
        <div className="text-white flex flex-col gap-4 pb-2">
            <p className="text-2xl">Overview of Templates</p>
            <p>
                Templates turn commonplace designs like social media posts, ads, business cards, and more into self
                serve layouts that team members can create customized assets from.
            </p>
            <p>
                Each template is a collection of designs that contain fields for team members to customize content.
                Currently, only Text and Images layers can be turned into fields
            </p>
            <img src={overviewImage} alt="overview" />
        </div>
    );
};
